
@if(form()){
<form [formGroup]="form()">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mb-3" >
        <spike-field-text formControlName="code" icon ="pi pi-barcode" label="ID Posizione" placeholder="Commessa-2025-001"></spike-field-text >
        <spike-field-text label="Titolo" formControlName="shortDescription"></spike-field-text>
        <spike-field-number label="Quantità" formControlName="quantity"></spike-field-number>
        <spike-field-date label="Data scadenza" formControlName="expireDate"></spike-field-date>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-1 gap-4 mb-3">
        <spike-field-text-area  label="Note" formControlName="description" > </spike-field-text-area>
    </div>


</form>
}
